module.exports = __webpack_public_path__ + "static/media/file-eps.1d56a3ad.svg";